import { z } from "zod";
export const rsvpPutBody = z.object({ status: z.enum(["going", "maybe", "no"]) });
export const shareEventBody = z.object({ conversationId: z.uuid() });
//# sourceMappingURL=events.js.map